import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLinkScroll } from '@/hooks/useLinkScroll';
import { filterCenturionProvidersForDisplay } from '@/helpers/utils';
import { termsAnchorTags, termsModalSessionKey } from '@/constants';

const PartnerTermsContent = ({ partners }) => {
  useLinkScroll('#scroll-link');
  // Filter partners so only 1 Centurion provider shows (each country Centurion Provider is a separate array entry)
  const filteredPartners = filterCenturionProvidersForDisplay(partners);

  useEffect(() => {
    if (global.BROWSER) {
      const urlAnchor = window.location.hash.slice(1);
      if (
        termsAnchorTags.includes(urlAnchor) &&
        window.sessionStorage.getItem(termsModalSessionKey) !== '1'
      ) {
        const anchorElement = document.querySelector(
          `#${urlAnchor}-terms-header`
        );
        if (anchorElement) {
          anchorElement.scrollIntoView({ behavior: 'smooth' });
          window.sessionStorage.setItem(termsModalSessionKey, '1');
        }
      }
    }
  }, []);

  return (
    <>
      {filteredPartners.map(
        ({ partner_name: partnerName, terms, partner_id: partnerId }) => (
          <React.Fragment key={partnerName}>
            <h3
              id={`${partnerId}-terms-header`}
              className="tw-text-xs tw-font-bold"
            >
              {partnerName}
            </h3>
            <p
              className="margin-2-b tw-text-xs a-children_tw-underline focus_a-children_tw-text-blue-bright-600"
              dangerouslySetInnerHTML={{
                __html: terms,
              }}
            />
          </React.Fragment>
        )
      )}
    </>
  );
};

PartnerTermsContent.propTypes = {
  partners: PropTypes.arrayOf(
    PropTypes.shape({
      partner_name: PropTypes.string,
      provider_id: PropTypes.string,
      logo: PropTypes.string,
      link_label: PropTypes.string,
      link_URL: PropTypes.string,
      terms: PropTypes.string,
      order: PropTypes.number,
    })
  ).isRequired,
};

export default PartnerTermsContent;
